import { useLocation } from 'react-router';

const useWithLocation = <T extends AnyFn>(fn: T): ReturnType<T> => {
    useLocation();

    return fn();
};

export default useWithLocation;
